import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { Product } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class ProductService implements RequestService {

  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'product';  // URL to web api

  constructor(
    private http: HttpClient,
    ) { }


  /** GET product by id. Will 404 if id not found */
  /** GET product by id. Will 404 if id not found */
  getProducts(val:string,includeAssets?:boolean): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let url = `${environment.baseURL}${this.serviceUrl}/${val}`;

    if(includeAssets)
      url +=`?include=productassets.media`
    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Product[]>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }


  getProduct(product:Product): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${product.id}/product`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Product>(url,{
       //params : httpParams
       headers: headers
    })

  }

  getProductMedia(uuid:String): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${uuid}/allmedia`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Product>(url,{
       //params : httpParams
       headers: headers
    })

  }

  getAllProductsMedia(products:Product[],offerUUID:string):Observable<any>{

    const requests = products.map(product => {

      var url = `${environment.baseURL}${this.serviceUrl}/${product.uuid}/allmedia`;

      if(offerUUID) {
        url += `/${offerUUID}?include=productassets.media&include=manufacturerProduct.productassets.media`;
      } else {
        url += `?include=productassets.media&include=manufacturerProduct.productassets.media`;
      }

      let urlSearchParams = new URLSearchParams();
      let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

      return this.http.get<Product>(url,{
         //params : httpParams
         headers: headers
      })
    });
    return Observable.forkJoin(requests);

  }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better product of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/product.service.ts